import { render, staticRenderFns } from "./ControlNotFound.vue?vue&type=template&id=5e407e7e&scoped=true&"
import script from "./ControlNotFound.vue?vue&type=script&lang=ts&"
export * from "./ControlNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./ControlNotFound.vue?vue&type=style&index=0&id=5e407e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e407e7e",
  null
  
)

export default component.exports